import { ErrorMessage } from '../../../../common/ErrorMessageUtil';
import { LoadingState } from '../../../Campaign/types';

export const SLICE_NAME = 'influencerSignupWizard';

export interface InfluencerSignupWizardState {
  signupInfluencerWithPasswordLoadingState: LoadingState;
  signupInfluencerWithPasswordError: ErrorMessage[] | null;
}
